import uniqBy from 'lodash.uniqby'
import isEmpty from 'lodash.isempty'
import { batchCreateEventType, batchEditEventType, createFieldValue } from '@fs/zion-sls'

/**
 * @typedef {Object} EVENT_FIELD_TYPES
 * @property {string} PLACE - The field type for place-related fields.
 * @property {string} DATE - The field type for date-related fields.
 * @property {string} EVENT - The field type for other event-related fields.
 */
export const EVENT_FIELD_TYPES = {
  PLACE: 'placeFields',
  DATE: 'dateFields',
  EVENT: 'otherFields',
}

/**
 * Gets event type suggestions based on provided types and primary flag.
 */
export const getEventTypeSuggestions = ({ types, t, isPrimary = false, showRelationshipEvents = true }) => {
  const filteredEvents = types?.events?.filter((type) => {
    const passPrimaryFilter = isPrimary ? true : !type.primaryOnly
    const passRelationshipFilter = showRelationshipEvents ? true : !type.elementTypes.includes('RELATIONSHIP')
    return passPrimaryFilter && passRelationshipFilter
  })

  const eventTypes = filteredEvents?.map((type) => ({
    ...type,
    key: type.eventType,
    primaryText: type.displayLabel,
    group: t('edit-events.fields.event-type', 'Event type'),
  }))

  return (
    uniqBy(eventTypes, 'key') || [
      { key: 'notImplementd', primaryText: t('add-person.types-not-implemented', 'Types Not Implemented') },
    ]
  )
}

/**
 * Edits an existing event type.
 */
export const editEventType = ({ attribution, el, value, eventTypeFieldId, types }) => {
  const eventTypeField = el?.subElements?.find((se) => se.fieldType === 'EVENT_TYPE')
  const eventType = types?.events?.find((ev) => ev.eventType === value)
  const eventTypeLabel = eventType?.displayLabel
  const typeFieldValue = createFieldValue(eventTypeLabel, attribution, eventType?.uri)

  const hasEventTypeField = !isEmpty(eventTypeField)
  if (hasEventTypeField) {
    return batchEditEventType({
      partitionKey: el.partitionKey,
      typeFieldValue,
      typeFieldId: eventTypeField.id,
    })
  }

  return batchCreateEventType({
    partitionKey: el.partitionKey,
    typeFieldId: eventTypeFieldId,
    typeFieldValue,
    elementId: el.id,
  })
}
